import { createContext } from 'react';
import { FiltersContextProps } from './filtersTypes';

export const FiltersContext = createContext<FiltersContextProps | undefined>(
  undefined,
);
